module.exports = __webpack_public_path__ + "/login_ui/img/ph-50f0fe14cab7395eae6d441fada38ba2.svg";